export default __webpack_public_path__ + "static/media/icon-menu.d85f0673.svg";